<template>
  <div class="page-container">
    <div class="page-header-wrapper icon-header">
      <div class="page-header">
        <div class="site-name">
          <div class="site-name-img">
            <img src="@/assets/logo-wihte.png" />
          </div>
          <div class="site-name-title">{{ sysInfo.brandName }}广告投放平台</div>
        </div>
        <div class="page-header-left">
          <el-button round @click="goLogin">返回登录</el-button>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="main-title">更新日志</div>
      <el-card v-for="(item, index) in changelogList" shadow="never" :key="index">
        <div slot="header" class="card-header">
          <div class="version">{{ item.version }}</div>
          <div class="time">{{ item.updateTime }}</div>
        </div>
        <template v-if="item.features && item.features.length">
          <div class="log-type">新特性</div>
          <ul class="log-list">
            <li v-for="(log, idx) in item.features" :key="idx">
              <span>• </span>
              <span v-html="log"></span>
            </li>
          </ul>
        </template>
        <template v-if="item.bugFix && item.bugFix.length">
          <div class="log-type">Bug修复</div>
          <ul class="log-list">
            <li v-for="(log, idx) in item.bugFix" :key="idx">
              <span>• </span>
              <span v-html="log"></span>
            </li>
          </ul>
        </template>
        <template v-if="item.optimizes && item.optimizes.length">
          <div class="log-type">优化</div>
          <ul class="log-list">
            <li v-for="(log, idx) in item.optimizes" :key="idx">
              <span>• </span>
              <span v-html="log"></span>
            </li>
          </ul>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      changelogList: []
    }
  },
  computed: {
    ...mapGetters(['sysInfo'])
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  created() {
    this.getChangeLog()
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    getChangeLog() {
      this.$service.getChangeLog().then(res => {
        if (res.length) {
          this.changelogList = res.map(item => {
            const contents = item.content ? JSON.parse(item.content) : {}
            return {
              version: item.version,
              updateTime: item.updateTime,
              ...contents
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-container
  min-height 100vh
  background #fff
  .page-header-wrapper
    height 60px
    width 100%
    .page-header
      display flex
      justify-content space-between
      width 88%
      margin 0 auto
      .site-name
        display flex
        align-items center
        color #fff
        font-weight 400
        .site-name-img
          height 1.4rem
          padding-right 1rem
          img
            max-height 100%
        .site-name-title
          padding-left 1rem
          font-size 16px
          border-left 1px solid #ddd
      .page-header-left .el-button
        background-color #ff8b00
        color #fff
        &:hover
          background-color #fff
          border-color #ff8b00
          color #ff8b00
  .main-title
    padding 20px 0
    font-size 28px
    font-weight bold
  .main-content
    margin 0 auto
    padding 20px
    width 66%
  .el-card
    margin-bottom 40px
.card-header
  display flex
  justify-content space-between
  .version
    font-size 18px
    font-weight bold
.log-type
  padding 20px 0
  font-size 16px
  font-weight bold
.log-list
  margin 0 0 0 20px
  padding 0
  line-height 30px
</style>
